/* This file is autogenerated, see readme.md for instructions */
import GiftSvgIcon from '@bloomreach/banana-theme/icons/gift.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const GiftIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <GiftSvgIcon />
    </Icon>
  );
});

GiftIcon.displayName = 'GiftIcon';

export default GiftIcon;
